export const API_URL = process.env.REACT_APP_API_URL as string;
export const JWT_SECRET = '123456' as string;
export const HOST_URL = process.env.REACT_APP_HOST as string;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;
export const SCOPE =
  'email profile https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.readonly' as string;
export const APP_PATH = process.env.REACT_APP_APPL_PATH as string | '';
